import { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

/** Menu for one store, with that store's price/availability overrides applied. */
export function useStoreMenu(storeId) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    if (!storeId) { setItems(null); return; }
    let active = true;
    api.get("/menu", { params: { store_id: storeId } })
      .then((r) => { if (active) setItems(r.data); })
      .catch(() => { if (active) setItems([]); });
    return () => { active = false; };
  }, [storeId]);
  return { items: items || [], loading: items === null };
}

/** Cart lines whose item is unavailable (or gone) at the given store's menu. */
export function useUnavailableLines(cartItems, storeMenu, loading) {
  return useMemo(() => {
    if (loading || !storeMenu.length) return [];
    const byId = new Map(storeMenu.map((m) => [m.id, m]));
    return cartItems.filter((line) => {
      const m = byId.get(line.item_id);
      return !m || m.is_available === false;
    });
  }, [cartItems, storeMenu, loading]);
}
